import { createRoot } from 'react-dom';
import { TotaliserBlock } from "./totaliser-block";

const divsToUpdate = document.querySelectorAll(".totaliser-app");

divsToUpdate.forEach((div) => {
  const data = JSON.parse(div.querySelector("pre").innerText);
  const container = document.getElementById(data.app_name);
  const root = createRoot(container);
  root.render(<Totaliser {...data} />);
  div.classList.remove("totaliser-app");
});

function Totaliser(props) {
  return <TotaliserBlock {...props} />;
}
